// extracted by mini-css-extract-plugin
export var paginationContainer = "_70-0";